// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-login-recovery',
    data: () => ({
        eMailAddress: "",
        errorMessage: ""
    }),
    created() {
        this.eMailAddress = host.login.getUsername() ?? '';
    },
    watch: {
        eMailAddress: function (val) {
            this.errorMessage = '';
        },
    },
    computed: {
        hasError() {
            return !utils.isEmpty(this.errorMessage);
        },
        disableSubmit() {
            return utils.isEmpty(this.eMailAddress);
        }
    },
    methods: {
        OnExecute() {
            host.api.post('identity/profile/password-recovery', null, { params: { address: this.eMailAddress } })
                .then((e) => {
                this.$router.push({ path: '/login/recovery', hash: '#submit' });
            })
                .catch((e) => {
                this.errorMessage = e.message;
            });
        },
        OnBack() {
            this.$router.push({ path: '/login' });
        }
    }
});
// #endregion
